import { defineStore } from 'pinia'
import * as Sentry from "@sentry/vue"

const getDefaultState = () => ({
  profile: null,
  role: null,
  isAdmin: false,
  notificationCount: 0,
});

export const useUserPartnerStore = defineStore('userPartner', {
  state: getDefaultState,
  persist: true,
  actions: {
    setLogin(payload) {

      const { user, token } = payload;
      
      this.profile = user;
      this.token = token;
      this.isAdmin = user.admin || false;
      
       localStorage.setItem("userToken", token);

      if (import.meta.env.VITE_APP_ENV === "production") {

        Sentry.setUser({
          id: `${user.customer_code}_${user.id}`,
          email: user.email,
      });
      }

    },
    setProfile(user) {
      this.profile = user;
      this.isAdmin = user.admin;
    },
   
    setToken(payload){

      const { token } = payload
      this.token = token

    },
    setLogout() {
      this.$reset(); // Resetear el store a su estado inicial
       localStorage.removeItem("userToken");
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    getProfile: (state) => state.profile,
    getIsAdmin: (state) => state.isAdmin
  },
})